/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Section_Payment_TermsInputs */

const en_clients_section_payment_terms = /** @type {(inputs: Clients_Section_Payment_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Parameters`)
};

const pt_br2_clients_section_payment_terms = /** @type {(inputs: Clients_Section_Payment_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parâmetros de Negociação`)
};

/**
* | output |
* | --- |
* | "Negotiation Parameters" |
*
* @param {Clients_Section_Payment_TermsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_section_payment_terms = /** @type {((inputs?: Clients_Section_Payment_TermsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Section_Payment_TermsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_section_payment_terms(inputs)
	return pt_br2_clients_section_payment_terms(inputs)
});